import { useTranslation, Trans } from 'react-i18next'
import classNames from 'classnames/bind'

import { Flex, IllustratedMessage } from '@percent/lemonade'
import { webLinks } from '@percent/partner-dashboard/constants/webLinks'
import { ContentOrErrorProps, SomethingWentWrongProps } from './SomethingWentWrong.types'
import styles from './SomethingWentWrong.module.scss'

const cx = classNames.bind(styles)

const helpLink = (
  // eslint-disable-next-line jsx-a11y/control-has-associated-label
  <a href={webLinks.HELP_CENTER} target="_blank" rel="noopener noreferrer" className={styles.linkHelpCenter} />
)

export function SomethingWentWrong({ title, description, hideWrapper = false }: Readonly<SomethingWentWrongProps>) {
  const { t } = useTranslation()

  return (
    <Flex direction="column" gap={16} className={cx({ container: !hideWrapper })}>
      <IllustratedMessage
        illustration="invalid-link"
        title={t(title ?? 'grants.somethingWentWrong.title')}
        description={
          <Trans
            // @ts-expect-error - i18nKey is not typed correctly
            i18nKey={description ?? 'grants.somethingWentWrong.description'}
            components={{
              a: helpLink
            }}
            values={{ helpCenter: t('grants.somethingWentWrong.helpCenter') }}
          />
        }
      />
    </Flex>
  )
}

export function ContentOrError({ children, error }: ContentOrErrorProps) {
  if (error) {
    return <SomethingWentWrong />
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
